/* eslint-disable react-hooks/exhaustive-deps */
import { Button, Table, Modal, Space } from "antd";
import axios from "axios";
import { useEffect, useState } from "react";

import CreateEditCourseContestModal from "./CreateEditContestsModal";
import { showErrorNotification, showSuccessNotification } from "../../../utils/notification";

const CourseContestsManagementModal = ({
  courseId,
  isModalOpen = false,
  setIsModalOpen = () => {},
  ROOT_URL
}) => {
  const BASE_URL = "admin/courses/contests";

  const [contestsList, setContestsList] = useState([]);

  const [isContestCreateEditModalOpen, setIsContestCreateEditModalOpen] = useState(false);
  const [initialValues, setInitialValues] = useState({});

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const fetchContestsLink = async () => {
    axios
      .get(`${ROOT_URL}/${BASE_URL}/list`, {
        params: {
          courseId
        }
      })
      .then((res) => {
        const { contests = [] } = res.data;
        setContestsList(contests);
        showSuccessNotification("Contests Fetched Successfully");
      })
      .catch((err) => {
        showErrorNotification(err);
      });
  };

  const handleContestDeletion = (contestId) => {
    axios
      .post(`${ROOT_URL}/${BASE_URL}/delete`, {
        contestId
      })
      .then(() => {
        showSuccessNotification("Contest deleted Successfully");
        fetchContestsLink();
      })
      .catch((err) => {
        showErrorNotification(err);
      });
  };

  const handleCreateEditCourseContest = (contestParams) => {
    if (initialValues?.key !== undefined) {
      axios
        .post(`${ROOT_URL}/${BASE_URL}/edit`, {
          contestId: initialValues?.key,
          contestParams
        })
        .then(() => {
          setIsContestCreateEditModalOpen(false);
          showSuccessNotification("Contest edited Successfully");
          fetchContestsLink();
        })
        .catch((err) => {
          showErrorNotification(err);
        });
    } else {
      axios
        .post(`${ROOT_URL}/${BASE_URL}/create`, {
          contestParams,
          courseId
        })
        .then(() => {
          setIsContestCreateEditModalOpen(false);
          showSuccessNotification("Contest created Successfully");
          fetchContestsLink();
        })
        .catch((err) => {
          showErrorNotification(err);
        });
    }
  };

  const columns = [
    {
      title: "S No.",
      dataIndex: "index",
      key: "index"
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name"
    },
    {
      title: "Contest Link",
      dataIndex: "contestLink",
      key: "contestLink"
    },
    {
      title: "Pre-requisite Test",
      dataIndex: "preRequisitesText",
      key: "preRequisitesText"
    },
    {
      title: "Editorial Link",
      dataIndex: "editorialLink",
      key: "editorialLink"
    },
    {
      title: "Created By",
      dataIndex: "createdBy",
      key: "createdBy"
    },
    {
      title: "Actions",
      key: "action",
      render: (row) => (
        <div
          id="course_subs_row_actions"
          style={{
            width: "300px",
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-around"
          }}
        >
          <Space wrap>
            <Button
              type="primary"
              onClick={() => {
                setInitialValues(row);
                setIsContestCreateEditModalOpen(true);
              }}
            >
              Edit
            </Button>
            <Button
              type="primary"
              danger
              onClick={() => {
                handleContestDeletion(row.key);
              }}
            >
              Delete
            </Button>
          </Space>
        </div>
      )
    }
  ];

  useEffect(() => {
    fetchContestsLink(1);
  }, []);

  return (
    <Modal
      title="Contests Management"
      open={isModalOpen}
      footer={[]}
      width={2500}
      onOk={handleOk}
      onCancel={handleCancel}
    >
      <br />
      <Button
        type="primary"
        onClick={() => {
          setInitialValues({});
          setIsContestCreateEditModalOpen(true);
        }}
      >
        Create Contest
      </Button>
      <br />
      <br />
      <p>This order of contests is same as the order on learnings page.</p>
      <Table
        columns={columns}
        dataSource={contestsList || []}
        bordered
        pagination={false}
        scroll={{ x: "max-content" }}
      />
      {isContestCreateEditModalOpen === true && (
        <CreateEditCourseContestModal
          isModalOpen={isContestCreateEditModalOpen}
          isEdit={initialValues?.key !== undefined}
          initialValues={initialValues}
          setIsModalOpen={setIsContestCreateEditModalOpen}
          handleCreateEditCourseContest={handleCreateEditCourseContest}
        />
      )}
    </Modal>
  );
};
export default CourseContestsManagementModal;
